import { ContextType } from "./context-type.enum";
import { StepConfig } from "./step-config.model";
import { StepType } from "./step-type.enum";

export class CreateAccountStepConfig extends StepConfig {

  // Per-flow HTML that replaces the default SMS consent text (and its links) next to the opt-in
  // checkbox. Empty means the built-in translated default. Other languages go in _i18n[lang].
  smsConsentText?: string;

  constructor(id: string, name: string | undefined, path: string, groupId: number | undefined) {
    super(id, name, path, groupId, ContextType.None);
    this.stepType = StepType.CreateAccount;
  }
}
